import PropTypes from 'prop-types'
import { useState } from 'react'
import { Button, ButtonGroup, FormControl, FormLabel, Input, Modal, ModalBody, ModalCloseButton, ModalContent, ModalFooter, ModalHeader, ModalOverlay, Textarea } from '@chakra-ui/react'
import { useAppContext } from 'hooks/useAppContext'
import { checkPassword } from 'api'

export const ModalPasswordConfirmationOnProjectCancel = ({ isOpen, onClose, heading, btnConfirmLabel = 'Confirm', btnCancelLabel = 'Cancel', onConfirm }) => {
  const { createToast } = useAppContext()
  const [reason, setReason] = useState('')
  const [password, setPassword] = useState('')

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleConfirm = async () => {
    if (!reason) {
      createToast('warning', 'Input reason.')
      return
    }

    if (!password) {
      createToast('warning', 'Input password.')
      return
    }

    setIsSubmitting(true)

    try {
      await checkPassword(password)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
      return
    }

    try {
      await onConfirm(reason)
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <Modal size="xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>{heading}</ModalHeader>
          <ModalCloseButton />
          <ModalBody>
            <FormControl isRequired>
              <FormLabel>Reason why project is being cancelled (require at least 140 characters)</FormLabel>
              <Textarea name="reason" rows={4} maxLength={140} value={reason} onChange={e => setReason(e.target.value)}></Textarea>
            </FormControl>
            <FormControl mt={4} isRequired>
              <FormLabel>Enter password below to continue.</FormLabel>
              <Input type="password" name="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </FormControl>
          </ModalBody>
          <ModalFooter>
            <ButtonGroup gap={4}>
              <Button colorScheme="blue" size="sm" onClick={handleConfirm} isLoading={isSubmitting}>{btnConfirmLabel}</Button>
              <Button variant="ghost" colorScheme="gray" size="sm" onClick={onClose}>{btnCancelLabel}</Button>
            </ButtonGroup>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  )
}

ModalPasswordConfirmationOnProjectCancel.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  heading: PropTypes.string,
  btnConfirmLabel: PropTypes.string,
  btnCancelLabel: PropTypes.string,
  onConfirm: PropTypes.func
}
